<template>
  <v-card
    light
    min-width="300"
    class="d-flex flex-column"
  >
    <v-card
      hieght="100"
    >
      <v-text-field
        :value="qrcode.amount && qrcode.amount.cost"
        readonly
        solo-inverted
        flat
        dense
        :prepend-icon="currencyIcon"
      />
      <v-icon
        class="mb-6 d-flex justify-center"
      >
        mdi-swap-vertical
      </v-icon>
      <v-text-field
        :value="qrcode.amount && qrcode.amount.price"
        readonly
        dense
        solo-inverted
        flat
      >
        <template slot="prepend">
          <v-img
            v-if="coin.logo"
            width="25"
            :src="require(`../../assets/${coin.logo}`)"
          />
        </template>
      </v-text-field>
    </v-card>
    <v-btn
      color="primary"
      elevation="0"
      :disabled="!isReady"
      @click="pay=true"
    >
      Pay using {{ coin.name }}
    </v-btn>

    <qrcode
      :show="pay"
      :coin="coin"
      :total-amount="totalAmount"
      @close="pay=false"
    />
  </v-card>
</template>

<script>
import Qrcode from './Qrcode'

export default {
  components: {
    Qrcode,
  },
  props: {
    coin: {
      type: Object,
      default: ()=>{return {}}
    },
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    isReady: {
      type: Boolean,
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    }
  },
  data() {
    return {
      qrcode: {},
      pay: false
    }
  },
  computed: {
    countdownDisplay() {
      return this.countdown.toFixed(2) 
    }
  },
  watch: {
    coin(){
      this.fetch()
    },
  },
  mounted () {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.busy = true
      this.qrcode = await this.api.get(`/crypto/qrcode/${this.coin.name}/${this.totalAmount}`)
      this.busy = false
    },
  },
}
</script>